import Immutable from 'seamless-immutable';

const filters = Immutable({
  category: 'PROTOCOL_CATEGORY',
  region: 'PROTOCOL_REGION',
});

export default filters;
